'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inlineStylePrefixer = require('inline-style-prefixer');

var _inlineStylePrefixer2 = _interopRequireDefault(_inlineStylePrefixer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var prefixer = new _inlineStylePrefixer2["default"]();

var loadmaskStyles = function loadmaskStyles(bgColor) {
  return prefixer.prefix({
    alignItems: 'center',
    backgroundColor: bgColor || '#424242',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: '100%',
    zIndex: 99999
  });
};

exports["default"] = loadmaskStyles;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-redux-loadmask/lib/shared/styles.js
 ** module id = 502
 ** module chunks = 0
 **/